import React from "react";
import { connect } from "react-redux";

import {
  Button,
  Fade,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";

import SectionHeader from "../../components/UI/SectionHeader";
import { getSorting, stableSort } from "../../utilities/sorting";

import { appAction, custodianAction } from "../../actions";

import { Trash } from "./components";

const styles = (theme) => ({
  input: {
    width: "340px",
    "& input": {
      color: theme.palette.primary.main,
    },
  },
  loadingContainer: {
    minHeight: 250,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    textAlign: "center",
  },
  newCustodianButton: {
    marginLeft: theme.spacing(2),
  },
  newCustodianInput: {
    width: 340,
  },
  saveButton: {
    marginLeft: 340 + theme.spacing(2),
  },
  sectionFooter: {
    marginTop: theme.spacing(2),
  },
  sectionHeader: {
    borderBottom: `1px solid ${theme.palette.grey[800]}`,
    marginBottom: theme.spacing(2),
  },
  wrapper: {
    minWidth: 200,
  },
});

class AdminCustodianList extends React.Component {
  internalIdPropertyName = "__adminCustodianListInternalId";
  newCustodianNameRef = React.createRef();
  custodianNameRefs = {};
  state = {
    custodians: null,
    newCustodianName: "",
  };

  constructor(props) {
    super(props);

    const { custodianMap } = props;

    const custodians = this.sortCustodianMap(custodianMap);
    this.createCustodianInternalIds(custodians);
    this.createCustodianNameRefs(custodians);

    this.state = Object.assign({}, this.state, {
      custodians,
    });
  }

  componentDidMount() {
    this.props.dispatch(appAction.setAdminNav(true));
    this.props.dispatch(appAction.toggleMainNav(false));
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { custodians } = nextState;

    this.createCustodianInternalIds(custodians);
    this.createCustodianNameRefs(custodians);
  }

  addCustodian = () => {
    const newCustodians = Array.from(this.state.custodians);
    const newCustodian = {
      name: this.newCustodianNameRef.current.value,
    };
    newCustodians.push(newCustodian);

    this.newCustodianNameRef.current.value = "";
    this.setState({
      custodians: this.sortCustodians(newCustodians),
    });
  };

  archiveCustodian = (custodianToArchive) => {
    const newCustodianMap = {};
    this.state.custodians.forEach((custodian) => {
      if (
        custodian[this.internalIdPropertyName] !==
        custodianToArchive[this.internalIdPropertyName]
      ) {
        newCustodianMap[custodian.id] = custodian;
      }
    });

    this.setState({
      custodians: this.sortCustodianMap(newCustodianMap),
    });
  };

  createCustodianInternalIds(custodians) {
    custodians.forEach((custodian) => {
      if (!custodian[this.internalIdPropertyName]) {
        custodian[this.internalIdPropertyName] = Math.random()
          .toString()
          .slice(2);
      }
    });
  }

  createCustodianNameRefs(custodians) {
    custodians.forEach((custodian) => {
      if (!this.custodianNameRefs[custodian[this.internalIdPropertyName]]) {
        this.custodianNameRefs[custodian[this.internalIdPropertyName]] =
          React.createRef();
      }
    });
  }

  handleNewCustodianNameChange = (event) => {
    this.setState({
      newCustodianName: event.target.value,
    });
  };

  saveCustodians = () => {
    const custodiansPayload = this.state.custodians.map((custodian) => {
      const internalId = custodian[this.internalIdPropertyName];
      const name = this.custodianNameRefs[internalId].current.value;

      return {
        id: custodian.id,
        name,
      };
    });

    this.newCustodianNameRef.current.value = "";
    this.props.dispatch(custodianAction.saveCustodians(custodiansPayload));
  };

  sortCustodians(custodians) {
    const orderBy = "name";
    const order = "asc";

    return stableSort(custodians, getSorting(order, orderBy));
  }

  sortCustodianMap(custodianMap) {
    const custodians = Object.values(custodianMap);
    return this.sortCustodians(custodians);
  }

  renderCustodian = (custodian) => {
    const { classes } = this.props;

    return (
      <div key={custodian[this.internalIdPropertyName]} className={classes.row}>
        <TextField
          className={classes.input}
          inputProps={{ "aria-label": custodian.name }}
          required
          inputRef={
            this.custodianNameRefs[custodian[this.internalIdPropertyName]]
          }
          defaultValue={custodian.name}
        />
        <Trash archiveCustodian={this.archiveCustodian} custodian={custodian} />
      </div>
    );
  };

  render() {
    const { classes, custodianUpdateError, loadingCustodians } = this.props;

    const { custodians, newCustodianName } = this.state;

    return (
      <Fade in>
        <div className={classes.wrapper}>
          <SectionHeader className={classes.sectionHeader} text={"Admin Custodians"} />
          <section >
            <TextField
              className={classes.newCustodianInput}
              inputProps={{ "aria-label": "Add Custodian" }}
              placeholder="Custodian Name"
              inputRef={this.newCustodianNameRef}
              onChange={this.handleNewCustodianNameChange}
            />
            <Button
              className={classes.newCustodianButton}
              color="primary"
              onClick={this.addCustodian}
              variant="contained"
              disabled={newCustodianName.length === 0 }
            >
              Add Custodian
            </Button>
          </section>
          <section>
            <div className={classes.formWrapper}>
              {custodians.map(this.renderCustodian)}
            </div>
          </section>
          <section className={classes.sectionFooter}>
            {custodianUpdateError ? (
              <Typography color="error">Unable to update Custodians</Typography>
            ) : null}
            <Button
              className={classes.saveButton}
              color="primary"
              onClick={this.saveCustodians}
              variant="contained"
              disabled={loadingCustodians}
            >
              Save
            </Button>
          </section>
        </div>
      </Fade>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    custodianMap: state.custodian.map,
    custodianUpdateError: state.custodian.updateError,
    loadingCustodians: state.custodian.loading,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(AdminCustodianList));



// WEBPACK FOOTER //
// ./src/containers/AdminCustodianList/index.jsx